var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.configObj
    ? _c("div", { staticClass: "page-container" }, [
        _c(
          "div",
          {
            staticClass: "diyStore",
            style: _vm.boxStyle,
            attrs: { id: "store" },
          },
          [
            _c(
              "div",
              { staticClass: "pictrue overflow", style: _vm.logoStyleRadius },
              [
                _c("img", {
                  attrs: { src: _vm.JavaMerchantConfigInfo.avatar, alt: "" },
                }),
              ]
            ),
            _c("div", { staticClass: "text" }, [
              _vm._m(0),
              _c("div", { staticClass: "merchantInfo flex" }, [
                _c("div", { staticClass: "mr6 self_min merType bg-color" }, [
                  _vm._v("自营"),
                ]),
                _c("div", { staticClass: "mr10 merType color-FAAD14" }, [
                  _vm._v(_vm._s(_vm.JavaMerchantBaseInfo.merType)),
                ]),
                _c("div", { staticClass: "score" }, [
                  _c(
                    "div",
                    { staticClass: "starsList flex" },
                    [
                      _vm._l(
                        _vm.JavaMerchantBaseInfo.starLevel,
                        function (itemn, indexn) {
                          return _c("div", { key: indexn }, [
                            _c("span", {
                              staticClass: "iconfont icon-pingfen textE93323",
                            }),
                          ])
                        }
                      ),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                Number(_vm.JavaMerchantBaseInfo.starLevel) < 5,
                              expression:
                                "Number(JavaMerchantBaseInfo.starLevel) < 5",
                            },
                          ],
                          staticClass: "flex",
                        },
                        _vm._l(_vm.noStarLevel, function (itemn, indexn) {
                          return _c("span", {
                            key: indexn,
                            staticClass: "iconfont icon-pingfen noCheck",
                          })
                        }),
                        0
                      ),
                    ],
                    2
                  ),
                ]),
              ]),
            ]),
            _c(
              "button",
              {
                staticClass: "merCollect",
                style: _vm.followColor,
                attrs: { "hover-class": "none" },
              },
              [
                _c("span", { staticClass: "iconfont icon-guanzhu" }),
                _vm._v(
                  _vm._s(
                    _vm.JavaMerchantBaseInfo.isCollect ? "已关注" : "关注"
                  ) + " "
                ),
              ]
            ),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "acea-row row-middle mb5" }, [
      _c("div", { staticClass: "name text333" }, [_vm._v("crmeb旗舰店")]),
      _c("div", { staticClass: "iconfont icon-xuanze text333" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }